interface ExperimentalMessage {
	messageTemplateId: string;
	statsigExperiment: string;
	statsigParameterName: string;
	statsigTestCohorts: string[];
	statsigAAExperiment?: string;
}

// Entries are iterated through using the ML ranking order - the order in the list is not important
export const EXPERIMENTAL_MESSAGES: ExperimentalMessage[] = [
	{
		messageTemplateId: 'confluence-3p-connector-nudge',
		statsigExperiment: 'post-office_3p_user_authentication_nudge',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variation'],
	},
	{
		messageTemplateId: 'confluence-auto-provisioning-edition-parity-trial-dialog',
		// https://switcheroo.atlassian.com/ui/gates/d0ba1046-934a-4af7-8294-e6ca8b846ab3/key/confluence_autoprovisioning_edition_parity
		statsigExperiment: 'confluence_autoprovisioning_edition_parity',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variation'],
	},
	{
		messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
		// https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
		statsigExperiment: 'confluence_audio_v3_changeboarding',
		statsigParameterName: 'isEnabled',
		statsigTestCohorts: ['true'],
	},
	{
		messageTemplateId: 'jira-twcg-810-personalised-rt-upgrade-free-customers',
		// https://switcheroo.atlassian.com/ui/gates/853a6e2a-161f-4a2e-930e-9f64b2484e18/key/twcg-810_jira_rt-free-customer-upgrade
		statsigExperiment: 'twcg-810_jira_rt-free-customer-upgrade',
		statsigAAExperiment: 'twcg-810_jira_rt-free-customer-upgrade-aa',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variation'],
	},
	{
		messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
		// https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
		statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
		statsigParameterName: 'cohort',
		statsigTestCohorts: ['variant1', 'variant2'],
	},
	{
		messageTemplateId: 'confluence-editor-smart-links-draggable-changeboard',
		// https://switcheroo.atlassian.com/ui/gates/21711b08-4650-432f-b602-ae2e47196152/key/cc_dnd_smart_link_changeboard_po_template
		statsigExperiment: 'cc_dnd_smart_link_changeboard_po_template',
		statsigParameterName: 'isEnabled',
		statsigTestCohorts: ['true'],
	},
];
